import { UpdateLocationInput } from "@/__graphql__/graphql";
import type { Dashboard__UpdateLocationScreen__RelationQueryQuery } from "@/__graphql__/graphql";
import LocalePicker from "@/components/LocalePicker";
import { Button, Divider, Flex, Form, Typography } from "antd";
import { ContactPersonsSection } from "./ContactPersonsSection/ContactPersonsSection";

interface UpdateLocationScreenImplProps {
  isSubmitting?: boolean;
  location: NonNullable<Dashboard__UpdateLocationScreen__RelationQueryQuery["relation"]>["locations"][number];
  relationId: string;
  onUpdateLocation: (location: Omit<UpdateLocationInput, "relationId" | "locationId">) => void;
}

export function UpdateLocationScreenImpl({ isSubmitting, location, relationId, onUpdateLocation }: UpdateLocationScreenImplProps) {
  const [form] = Form.useForm<{ locale: string }>();

  const handleOnSubmit = async (values: { locale: string }) => {
    onUpdateLocation(values);
  };

  return (
    <div style={{ padding: 24, maxWidth: 1200, margin: "0 auto" }}>
      <Flex gap="middle" vertical>
        <Typography.Title level={2} style={{ margin: 0, padding: 0 }}>
          "{location.name}"
        </Typography.Title>

        <Form form={form} layout="vertical" initialValues={{ locale: location.locale }} onFinish={handleOnSubmit}>
          <Form.Item label="Taalinstelling" name="locale" required>
            <LocalePicker />
          </Form.Item>

          <Button type="primary" htmlType="submit" loading={isSubmitting}>
            Opslaan
          </Button>
        </Form>

        <Divider>Contactpersonen</Divider>
        <ContactPersonsSection contactPersons={location.contactPersons} locationId={location.id} relationId={relationId} />
      </Flex>
    </div>
  );
}
